export default "__VITE_ASSET__e_3NOtLt__"